/* Public 'just sold today' scrolling marquee. */
import { useCallback, useEffect, useState } from "react";
import { API } from "../lib/api";

const REFRESH_MS = 60 * 1000; // poll every 60s

export default function SoldMarquee() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("ssc_marquee_dismissed") === "1");

  const fetchData = useCallback(async () => {
    try {
      const r = await fetch(`${API}/public/sold-announcements`);
      if (r.ok) setData(await r.json());
    } catch (e) { /* silent */ }
  }, []);

  useEffect(() => {
    fetchData();
    const id = setInterval(fetchData, REFRESH_MS);
    return () => clearInterval(id);
  }, [fetchData]);

  if (dismissed) return null;
  if (!data || !data.currently_open || !data.items?.length) return null;

  const dismiss = () => {
    sessionStorage.setItem("ssc_marquee_dismissed", "1");
    setDismissed(true);
  };

  // Duplicate items so the loop reads continuously
  const loop = [...data.items, ...data.items];

  return (
    <div className="ssc-sold-marquee" data-testid="sold-marquee">
      <div className="ssc-sold-marquee-track">
        {loop.map((it, i) => (
          <span key={`${it.id}-${i}`} className="ssc-sold-marquee-item" data-testid={i < data.items.length ? `marquee-item-${it.id}` : undefined}>
            <span className="ssc-sold-marquee-emoji">🎉</span>
            <strong>{it.customer}</strong> just drove home in a <strong>{it.vehicle}</strong>!
            <span className="ssc-sold-marquee-dot">·</span>
          </span>
        ))}
      </div>
      <button onClick={dismiss} className="ssc-sold-marquee-close" aria-label="Hide announcement" data-testid="marquee-close">×</button>
      <style>{`
        .ssc-sold-marquee {
          position: relative;
          background: linear-gradient(90deg, #006DFF 0%, #001a4d 100%);
          color: #fff;
          overflow: hidden;
          font-size: 13px;
          padding: 8px 32px 8px 12px;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
        }
        .ssc-sold-marquee-track {
          display: inline-flex;
          gap: 0;
          white-space: nowrap;
          animation: ssc-marquee-scroll 45s linear infinite;
        }
        .ssc-sold-marquee:hover .ssc-sold-marquee-track {
          animation-play-state: paused;
        }
        .ssc-sold-marquee-item {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding-right: 36px;
        }
        .ssc-sold-marquee-emoji { font-size: 16px; margin-right: 2px; }
        .ssc-sold-marquee-dot { color: rgba(255,255,255,.4); margin-left: 24px; }
        .ssc-sold-marquee-close {
          position: absolute;
          top: 50%;
          right: 8px;
          transform: translateY(-50%);
          background: rgba(255,255,255,.15);
          color: #fff;
          border: 0;
          border-radius: 50%;
          width: 22px;
          height: 22px;
          line-height: 1;
          font-size: 16px;
          cursor: pointer;
          padding: 0;
        }
        .ssc-sold-marquee-close:hover { background: rgba(255,255,255,.3); }
        @keyframes ssc-marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .ssc-sold-marquee-track { animation: none; }
        }
      `}</style>
    </div>
  );
}
